import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Tooltip } from '../../components/Tooltip';
import { Icon } from '../Icon';
import { StyledIcon, StyledToggle } from './Toggle.style';
export function Toggle({ icon, label, title, size = 'Medium', children, disabled = false, shape = 'default', active, onClick, iconPosition, }) {
    var _a;
    const [isActive, setIsActive] = useState(active);
    useEffect(function updateActiveWhenPropChange() {
        setIsActive(active);
    }, [active]);
    return (_jsx(Tooltip, { text: title, visible: !!title, children: _jsxs(StyledToggle, { title: label, size: size, disabled: disabled, iconPosition: iconPosition !== null && iconPosition !== void 0 ? iconPosition : 'start', onClick: () => {
                setIsActive((previous) => {
                    onClick(!previous);
                    return !previous;
                });
            }, shape: shape, active: isActive, children: [icon && (_jsx(StyledIcon, { children: _jsx(Icon, { name: icon.name, size: (_a = icon.size) !== null && _a !== void 0 ? _a : 'Medium', color: icon.color }) })), children || label] }) }));
}
//# sourceMappingURL=Toggle.js.map